import mutations from './mutations'
import actions from './actions'
import getters from './getters'
const state = {
    experts: localStorage.getItem('experts') && JSON.parse(localStorage.getItem('experts')) || [],
    interests: localStorage.getItem('interests') && JSON.parse(localStorage.getItem('interests')) || []
};

const module = {
    state,
    getters,
    mutations,
    actions
};

export default module;



// WEBPACK FOOTER //
// ./src/store/modules/experts/index.js